import { Pipe, PipeTransform } from '@angular/core';
import { RegiaoDto } from '../models/regiao-dto';

@Pipe({
  name: 'regioesPipe'
})
export class RegioesPipe implements PipeTransform {

  transform(regioes: RegiaoDto[]): string[] {
    return regioes.map(regiao => {
      if (regiao == null) {
        return "";
      }

      return regiao.codigo.toString() + " " + regiao.descricao;
    });
  }
}